import request from '../utils/request'

export function login (data) {
  return request({
    url: '/api/auth/hlogin',
    method: 'post',
    data
  })
}
export function myinfo () {
  return request({
    url: '/api/member/myinfo',
    method: 'post'
  })
}
export function passReset (data) {
  return request({
    url: '/api/member/password-reset',
    method: 'post',
    data
  })
}
export function getAboutHome () {
  return request({
    url: '/about/home',
    method: 'get'
  })
}
export function getAboutContent () {
  return request({
    url: '/about/content',
    method: 'get'
  })
}
export function getNewsList (data) {
  return request({
    url: '/news',
    method: 'get',
    params: data
  })
}
export function getNewsInfo (id) {
  return request({
    url: '/news/' + id,
    method: 'get'
  })
}
export function getBannerList (data) {
  return request({
    url: '/banners',
    method: 'get',
    params: data
  })
}
export function getStaffList (data) {
  return request({
    url: '/staff',
    method: 'get',
    params: data
  })
}
export function getStaffInfo (id) {
  return request({
    url: '/staff/' + id,
    method: 'get'
  })
}

export function sendMsg (data) {
  return request({
    url: '/api/feedbacks',
    method: 'post',
    data
  })
}
